import { AbstractItemDelegate } from '@leverege/molten/data-source'
import Can from '@leverege/api-redux/lib/interface/Can'
import Obj from '@leverege/api-redux/lib/interface/Obj'
import InterfaceReducer from '@leverege/api-redux/lib/interface/InterfaceReducer'
import { GlobalState } from '@leverege/ui-redux'

export default class EventsItemDelegate extends AbstractItemDelegate {
  static TYPE = 'imagine.EventsItemDelegate'

  constructor( options ) {
    super( options )
    const { match, relationship } = options
    this.match = match
    this.relationship = relationship.isResolved ? relationship : relationship.createResolved( match )
    this.systemId = relationship.systemId
    this.id = this.relationship.id
    this.can = new Can( this.getInterfaceUrl(), false, false )
    this.type = EventsItemDelegate.TYPE
  }

  getInterfaceUrl() {
    return this.relationship.objRefUrl
  }

  createObj() {
    const pUrl = this.relationship.ref
    return Obj.create( pUrl, this.id, this.relationship.attributes != null )
  }

  search( query, options ) {
    return this.createObj().events( query, options )
  }

  canList( state = GlobalState.get(), requestIfUnavailable = true ) {
    const can = this.can.getHistory( state )
    if ( can == null && requestIfUnavailable ) {
      GlobalState.dispatch( this.requestCanList() )
    }
    return can
  }

  /**
   * Returns a redux action that will ask the api if you can get events at the current path
   * @param {object} query  query object to send to the api
   */
  requestCanList( query ) {
    return this.can.events( query )
  }

  // eslint-disable-next-line
  getList( state = GlobalState.get(), queryName, options ) {
    return InterfaceReducer.getHistory( state, `${this.getInterfaceUrl()}.events`, queryName, options )
  }
}
